/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ClearClusterPriceRequest = {
  model: string;
};

/** @internal */
export const ClearClusterPriceRequest$inboundSchema: z.ZodType<
  ClearClusterPriceRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  model: z.string(),
});
/** @internal */
export type ClearClusterPriceRequest$Outbound = {
  model: string;
};

/** @internal */
export const ClearClusterPriceRequest$outboundSchema: z.ZodType<
  ClearClusterPriceRequest$Outbound,
  z.ZodTypeDef,
  ClearClusterPriceRequest
> = z.object({
  model: z.string(),
});

export function clearClusterPriceRequestToJSON(
  clearClusterPriceRequest: ClearClusterPriceRequest,
): string {
  return JSON.stringify(
    ClearClusterPriceRequest$outboundSchema.parse(clearClusterPriceRequest),
  );
}
export function clearClusterPriceRequestFromJSON(
  jsonString: string,
): SafeParseResult<ClearClusterPriceRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ClearClusterPriceRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ClearClusterPriceRequest' from JSON`,
  );
}
